import {
  assign, endpoint, options, check, convert,
} from '../../helpers';
import models from './models';

/**
 * Saves database information
 *
 * @param {Object} props All parameter object used in the process
 * @param {Object=} props.data All data from the interface
 * @param {function=} props.dispatch Redux dispatcher
 * @param {function=} props.error Failed callback function
 * @param {function=} props.success Successful callback function
 */

const save = (properties) => {
  const state = assign(properties);
  const model = models.request(state.data);

  fetch(endpoint('/database-save'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        state.success(convert(response.Message));
      } else {
        state.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default save;
